import { ToastProvider } from "@/components/ui/toast";
import { Navbar } from "@/components/layout/navbar";
import { Footer } from "@/components/layout/footer";
import { Hero } from "@/features/landing/hero";
import { Features } from "@/features/landing/features";
import { HowItWorks } from "@/features/landing/how-it-works";
import { SocialProof } from "@/features/landing/social-proof";
import { FAQ } from "@/features/landing/faq";
import { WaitlistForm } from "@/features/landing/waitlist-form";
import { CTA } from "@/features/landing/cta";

export default function App() {
  return (
    <ToastProvider>
      <a
        href="#beranda"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[1001] focus:rounded-md focus:bg-surface-2 focus:px-4 focus:py-2 focus:text-sm"
      >
        Lewati ke konten utama
      </a>
      <Navbar />
      <main>
        <Hero />
        <Features />
        <HowItWorks />
        <SocialProof />
        <FAQ />
        <WaitlistForm />
        <CTA />
      </main>
      <Footer />
    </ToastProvider>
  );
}
